import {
  BG_STYLES,
  BORDER_STYLES,
  COMMON_STYLES,
  RightArrowIcon,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import React from "react";
import { useTranslation } from "react-i18next";
import { Pressable, Text, View } from "react-native";

interface Props {
  handleUpload: () => void;
  handleAddFarmer: () => void;
}

const SelectUser = ({ handleUpload, handleAddFarmer }: Props) => {
  const { t } = useTranslation();
  return (
    <View style={[COMMON_STYLES.flex1, BG_STYLES.bgWhite]}>
      <View style={[COMMON_STYLES.ph1]}>
        <Pressable onPress={handleUpload}>
          <View
            style={[
              COMMON_STYLES.row,
              BORDER_STYLES.borderNeutral20,
              COMMON_STYLES["br1/2"],
              COMMON_STYLES["ph3/4"],
              COMMON_STYLES["pv3/4"],
              COMMON_STYLES.alignItemsCenter,
              COMMON_STYLES.justifyBetween,
              COMMON_STYLES.b1,
            ]}
          >
            <Text
              style={[
                TEXT_STYLES.textPrimary100,
                TYPOGRAPHY.TEXT1,
                VARIANTS_STYLES.SEMI_EMPHASIZED,
              ]}
            >
              {t("my_crop")}
            </Text>
            <RightArrowIcon width={18} height={18} strokeColor="primary100" />
          </View>
        </Pressable>
        <Pressable onPress={handleAddFarmer}>
          <View
            style={[
              COMMON_STYLES.row,
              COMMON_STYLES.mt1,
              BORDER_STYLES.borderNeutral20,
              COMMON_STYLES["br1/2"],
              COMMON_STYLES["ph3/4"],
              COMMON_STYLES["pv3/4"],
              COMMON_STYLES.alignItemsCenter,
              COMMON_STYLES.justifyBetween,
              COMMON_STYLES.b1,
            ]}
          >
            <Text
              style={[
                TEXT_STYLES.textPrimary100,
                TYPOGRAPHY.TEXT1,
                VARIANTS_STYLES.SEMI_EMPHASIZED,
              ]}
            >
              {t("other_farmer_crop")}
            </Text>
            <RightArrowIcon width={18} height={18} strokeColor="primary100" />
          </View>
        </Pressable>
      </View>
    </View>
  );
};

export default SelectUser;
